
import configLocal  from './local';
import configDev  from './development';
import configStag  from './staging';
import configPro  from './production';

//const env = 'local';
//const env = 'development';
const env = 'staging';
// const env = 'production';
let config;

switch(env) {
  case 'local': 
  {
    config = configLocal;
    break;
  };
  case 'development': 
  {
    config = configDev;
    break;
  };
  case 'staging': 
  {
    config = configStag;
    break;
  };
  case 'production': 
  {
    config = configPro;
    break;
  };
}

export default config;
